import { Home, CalendarDays, Circle, Check, Settings, Users, Dog, Edit3, Trash2, Save, PlusCircle, Moon, Sun, Search, AlertTriangle, X, ClipboardList, Info, CalendarPlus, Pin, PinOff } from 'lucide-react';

export const APP_NAME = "RUTAPP";
export const APP_VERSION = "1.0.0";

export const USERS = {
  DAVID: "David",
  SARA: "Sara",
};

export const DAYS_OF_WEEK = [
  "DOMINGO",
  "LUNES",
  "MARTES",
  "MIÉRCOLES",
  "JUEVES",
  "VIERNES",
  "SÁBADO",
];

export const ALL_DAYS_KEYS = [
  "LUNES",
  "MARTES",
  "MIÉRCOLES",
  "JUEVES",
  "VIERNES",
  "SÁBADO",
  "DOMINGO",
];

export const MONTH_NAMES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export const DEFAULT_DOG_SETTINGS = {
  duration: 30,
  frequency: "daily",
  notes: "",
};

export const MAX_DOG_NAME_LENGTH = 25;
export const MAX_NOTES_LENGTH = 200;

export const UI_THEMES = {
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
};

export const LOCAL_STORAGE_KEYS = {
  DAYS_LIST: "DAYS_LIST_V3", 
  COMPLETED_DOGS: "COMPLETED_DOGS_V3",
  URGENT_DOGS: "URGENT_DOGS_V3",
  SELECTED_USER: "SELECTED_USER_V2",
  CURRENT_DATE: "CURRENT_DATE_V2",
  UI_THEME: "UI_THEME_V1",
  APP_SETTINGS: "APP_SETTINGS_V1",
  LAST_ACTIVE_DATE: "LAST_ACTIVE_DATE_V1",
  HISTORY_STATE_PREFIX: "HISTORY_STATE_V1_",
  APP_CONFIG: "APP_CONFIG_V1",
  PERMANENTLY_DELETED_DOGS: "PERMANENTLY_DELETED_DOGS_V1"
};

export const ICONS = {
  Home,
  CalendarDays,
  Circle,
  Check,
  Settings,
  Users,
  Dog,
  Edit: Edit3,
  Delete: Trash2,
  Save,
  Add: PlusCircle,
  Moon,
  Sun,
  Search,
  Warning: AlertTriangle,
  Close: X,
  ClipboardList,
  Info,
  CalendarPlus,
  Pin,
  PinOff
};

export const ANIMATION_VARIANTS = {
  fadeIn: {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  },
  slideInUp: {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 100 } },
  },
  scaleUp: {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.3 } },
  },
};

export const TOAST_MESSAGES = {
  DOG_ADDED: "¡Perro añadido con éxito!",
  DOG_UPDATED: "¡Datos del perro actualizados!",
  DOG_DELETED: "Perro eliminado.",
  ALL_CLEARED: "Todas las marcas borradas para hoy.",
  ALL_CHECKED: "Todos los perros marcados como completados.",
  CHANGES_SAVED: "Cambios guardados.",
  SETTINGS_UPDATED: "Configuración actualizada.",
  USER_CHANGED: (user) => `Cambiado al usuario: ${user}`,
  ERROR_GENERAL: "Ha ocurrido un error.",
  ERROR_LOADING_DATA: "Error cargando los datos.",
  ERROR_SAVING_DATA: "Error guardando los datos.",
  UNDO_SUCCESS: "Acción deshecha.",
  REDO_SUCCESS: "Acción rehecha.",
  NO_MORE_UNDO: "No hay más acciones que deshacer.",
  NO_MORE_REDO: "No hay más acciones que rehacer.",
};

export const INITIAL_DOG_STRUCTURE = {
  id: '',
  name: '',
  info: '',
  photo: '',
  days: {
    LUNES: false,
    MARTES: false,
    MIÉRCOLES: false,
    JUEVES: false,
    VIERNES: false,
    SÁBADO: false,
    DOMINGO: false,
  },
  urgent: false,
  completed: false,
  order: 0,
  isFixed: true, 
};

export const TRANSITION_DURATION = 0.3;

const CLEO_WHATSAPP_LINK = "https://chat.whatsapp.com/FauGuvxQZSn3lxcArqPYEo";

export const INITIAL_DAYS_DAVID = {
  LUNES: [],
  MARTES: [],
  MIÉRCOLES: [],
  JUEVES: [],
  VIERNES: [],
  SÁBADO: [],
  DOMINGO: [],
};

export const INITIAL_DAYS_SARA = {
  LUNES: [],
  MARTES: [],
  MIÉRCOLES: [],
  JUEVES: [],
  VIERNES: [],
  SÁBADO: [],
  DOMINGO: [],
};